<template>
  <div>
    <v-container>
      <MedcardPatientFeature />

      <TelemedPatientFeature
        v-if="locale.isRu"
        class="feature-section"
      />

      <AppointmentPatientFeature
        v-if="locale.isRu"
        class="feature-section"
      />

      <HelpOtherPatientsFeature />
    </v-container>

    <FooterBanner />
  </div>
</template>

<script setup lang="ts">
import { generatePageMetaLinks } from '~/core/seo'
import FooterBanner from '~/features/Home/components/FeaturesSection/PatientFeatures/FooterBanner.vue'
import TelemedPatientFeature from '~/features/Home/components/FeaturesSection/PatientFeatures/TelemedPatientFeature.vue'
import MedcardPatientFeature from '~/features/Home/components/FeaturesSection/PatientFeatures/MedcardPatientFeature.vue'
import AppointmentPatientFeature from '~/features/Home/components/FeaturesSection/PatientFeatures/AppointmentPatientFeature.vue'
import HelpOtherPatientsFeature
  from '~/features/Home/components/FeaturesSection/HelpOtherPatientsFeature/HelpOtherPatientsFeature.vue'

const locale = useAppLocale()

useHead({
  link: generatePageMetaLinks(),
})
</script>
